/**
 * 支払タイプ名マップ
 */
export const paymentTypeNameMap = {
  /** 施設での徴収 */
  nursery: '施設側での徴収',
  /** クレジットカード */
  creditCard: 'クレジットカード',
};

/**
 * 支払タイプリスト
 */
export const PAYMENT_TYPE_TYPE = [
  'nursery', // 保育園側での直接徴収
  'creditCard', // クレジットカード徴収
] as const;

/** 支払タイプ */
export type PaymentTypeType = typeof PAYMENT_TYPE_TYPE[number];
